/**
 * Created by hp on 2017/6/30.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import WKDialog from '../../components/WKDialog';
import {renderMoney} from '../../utils';

import '../../styles/channel/ChannelMonthGiftDialog.css';

class ChannelMonthGiftDialog extends Component{
    constructor() {
        super();
        this.onRequestClose = this.onRequestClose.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleMonthSelect = this.handleMonthSelect.bind(this);
    }

    onRequestClose() {
        this.props.dispatch({
            type: 'CHANNEL_HIDE_MONTH_GIFT_DIALOG'
        });
    }

    handleNext() {
        this.props.dispatch({type: 'CHANNEL_HIDE_MONTH_GIFT_DIALOG'});
        this.props.dispatch({type: 'GIFT_SHOW_DIALOG'});
    }

    handleMonthSelect(e) {
        this.props.dispatch({
            type: 'CHANNEL_SELECT_MONTH_PAY',
            payload: {
                priceRecordId: e.currentTarget.dataset.id,
                priceRecordMoney: e.currentTarget.dataset.money,
            }
        });

        this.props.dispatch({
            type: 'GIFT_RESET',
            payload: {
                money: e.currentTarget.dataset.money,
                paySubProductKey: 'price_record_id',
                subProductId: e.currentTarget.dataset.id,
            }
        })
    }

    render() {
        let {showMonthGiftDialog, priceList} = this.props;
        return(
            <div className="channel-month-gift-dialog">
                <WKDialog
                    title={<span style={{color: '#3cc51f', fontSize: '1.1rem'}}>选择赠礼套餐</span>}
                    closeText="下一步"
                    onClick={this.handleNext}
                    onRequestClose={this.onRequestClose}
                    show={showMonthGiftDialog}>
                    <div className="mg-container">
                        {priceList.map((item) => (
                            <div className="weui-flex mg-item" key={item.id} onClick={this.handleMonthSelect} data-id={item.id} data-money={item.money}>
                                <span className="weui-flex__item text-left flex_4">
                                    <i className={"iconfont icon-zhengque " + (item.selected ? "month-selected" : "month-no-selected")}/>
                                    <span className="padding-left">{item.month}个月套餐</span>
                                </span>
                                    <span className="weui-flex__item text-right flex_2">
                                    <span className="key-num fr">￥{renderMoney(item.money)}</span>
                                </span>
                            </div>
                        ))}
                    </div>
                </WKDialog>
            </div>
        )
    }
}

export default connect((state) => ({
    showMonthGiftDialog: state.channel.showMonthGiftDialog,
    priceList: state.channel.channel.price_list
}))(ChannelMonthGiftDialog)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelMonthGiftDialog.js